import { Routes } from '@angular/router';

import { authenticationRoutes } from './authentication/authentication.routes';
import { authGuard } from './core/guards/auth.guard';
import { passwordChangeRequiredGuard } from './core/guards/password-change-required.guard';
import { redirectToFirstModuleGuard } from './core/guards/redirect-to-first-module.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard, passwordChangeRequiredGuard],
    children: [
      { path: '', pathMatch: 'full', canActivate: [redirectToFirstModuleGuard], children: [] },
      {
        path: 'sin-secciones',
        loadComponent: () =>
          import('./authentication/features/no-sections-assigned/no-sections-assigned.component').then(
            (m) => m.NoSectionsAssignedComponent,
          ),
      },
      {
        path: 'administrador',
        loadChildren: () => import('./administration/administration.routes').then((m) => m.administrationRoutes),
      },
      {
        path: 'documentos',
        loadChildren: () => import('./documents/documents.routes').then((m) => m.documentsRoutes),
      },
      {
        path: 'viajes',
        loadChildren: () => import('./travels/travels.routes').then((m) => m.travelsRoutes),
      },
      {
        path: 'transporte',
        loadChildren: () => import('./transport/transport.routes').then((m) => m.transportRoutes),
      },
      {
        path: 'locaciones',
        loadChildren: () => import('./locations/locations.routes').then((m) => m.locationsRoutes),
      },
      { path: 'notificaciones', pathMatch: 'full', redirectTo: 'administrador/notificaciones' },
      {
        path: 'contabilidad',
        loadChildren: () => import('./rates/rates.routes').then((m) => m.ratesRoutes),
      },
    ],
  },
  
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: authenticationRoutes,
  },

    { path: '**', redirectTo: '' },
];
